// Intercom help documentation URLs based on user's language
const INTERCOM_HELP_URLS = {
    'en-us': 'https://intercom.help/iotorq-lean/en/',
    es: 'https://intercom.help/iotorq-lean/es/',
    'fr-fr': 'https://intercom.help/iotorq-lean/fr/'
    // pt-br: Not yet available in Intercom
};

export function getHelpUrl(lang) {
    if (lang in INTERCOM_HELP_URLS) {
        return INTERCOM_HELP_URLS[lang];
    }
    // Default to English if language not found
    return INTERCOM_HELP_URLS['en-us'];
}
